





























































































import { Component, Ref, Watch } from "vue-property-decorator";
import Vue from "vue";
import { getModule } from "vuex-module-decorators";
import Viewpoints from "@/store/modules/Viewpoints";
import Decisions from "@/store/modules/Decisions";
import Choices from "@/store/modules/Choices";
import ViewpointListInput from "@/components/Lists/ViewpointListInput.vue"
import ChoiceListInput from "@/components/Lists/ChoiceListInput.vue"
import FactorListInput from "@/components/Lists/FactorListInput.vue"

@Component({
    components: {
        ChoiceListInput,
        FactorListInput,
        ViewpointListInput
    }
})

export default class ListManager extends Vue {

    private show: boolean = false;
    private tabs: string[] = ["CHOICE", "FACTOR", "VIEWPOINT"]
    private tab: string = "CHOICE"
    
    private cancel() {
        this.show = false;
    }
}

